export default theme => ({
  root: {
    background: '#fff',
    height: 75,
    zIndex: 100,
    // position: 'fixed',
    // width: '100%',
    // overflow: 'hidden',
    // borderBottom: ' 1px solid #e0e0e0',
    '-mozBoxShadow': '1px 1px 5px #ccc',
    '-webkitBoxShadow': '1px 1px 5px #ccc',
    boxShadow: '1px 1px 5px #ccc',
    // marginBottom: '75px',
    // position: 'absolute',
    // right: 0,
  },
  toolbar: {
    padding: 0,
    alignItems: 'stretch',
    display: 'flex',
    justifyContent: 'space-between',
  },
  rowsWrapper: {
    width: '100%',
    [theme.breakpoints.down("xs")]: {
      display: 'none'
    }
  },
  rowTop: {
    display: 'flex',
    justifyContent: 'flex-end',
    [theme.breakpoints.down("xs")]: {
      display: 'none'
    }
  },
  rowBottom: {
    display: 'flex',
    justifyContent: 'flex-end'
  },
  menuList: {
    margin: 0,
    padding: 0
  },
  socialIcons: {
  },
  searchBox: {
    [theme.breakpoints.down("xs")]: {
      display: 'none'
    }
  },

  spacer: {
    height: 75
  }
});